import React, { FC } from 'react';
import CounterCircle, { CounterCircleProps } from './CounterCircle';
import { View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import CounterButton, { CounterButtonType } from '@components/operatorPanel/components/elements/buttons/CounterButton';
import { connect } from 'react-redux';
import { ncFileStatuses } from '@helpers';
import { font as initialFont } from '@styles/fonts';
import { PanelProps } from '@components/operatorPanel/components/panel';

export interface CounterProps
  extends Omit<CounterCircleProps, 'size' | 'strokeWidth'>,
    Pick<PanelProps, 'isOperator'> {
  shouldDisplayMinusButton?: boolean;
  shouldDisplayPlusButton?: boolean;
  counterCircleSize?: number;
  counterButtonSize?: number;
  counterCircleStrokeWidth?: number;
  onMinusButtonPress: () => void;
  onPlusButtonPress: () => void;
  isWithERP: boolean | null;
  machineStatus: string;
  ncFileStatus: (typeof ncFileStatuses)[keyof typeof ncFileStatuses];
}

const CounterComponent: FC<CounterProps> = ({
  CC,
  bgColor,
  count,
  shouldDisplayMinusButton = true,
  shouldDisplayPlusButton = true,
  targetCount,
  counterCircleSize = 330,
  counterButtonSize = 90,
  counterCircleStrokeWidth = 12,
  onMinusButtonPress,
  onPlusButtonPress,
  isWithERP,
  ncFileStatus,
  machineStatus,
  isOperator,
  scale = initialScale,
  font = initialFont,
}) => {
  const shouldDisplayButtons = isOperator;

  const displayMinusButton = shouldDisplayMinusButton && count > 0 && shouldDisplayButtons;
  const displayPlusButton = shouldDisplayPlusButton && shouldDisplayButtons;

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: scale(47) }}>
      <CounterButton
        {...{
          CC,
          type: CounterButtonType.SUBTRACT,
          size: counterButtonSize,
          onPress: onMinusButtonPress,
          shouldDisplay: !!displayMinusButton,
          scale,
        }}
      />
      <CounterCircle
        {...{
          CC,
          bgColor,
          count,
          targetCount,
          size: counterCircleSize + counterCircleStrokeWidth,
          strokeWidth: counterCircleStrokeWidth,
          scale,
          font,
        }}
      />
      <CounterButton
        {...{ CC, type: CounterButtonType.ADD, size: counterButtonSize, onPress: onPlusButtonPress, shouldDisplay: !!displayPlusButton, scale }}
      />
    </View>
  );
};

const Counter = connect(({ membership: { isWithERP } }) => ({ isWithERP }), {})(CounterComponent);

export default Counter;
